import { resolveVendorDirectoryApiBase } from "./clientPortalFetch.js";

function base(clientViewId) {
  return `${resolveVendorDirectoryApiBase(clientViewId)}/marketplace`;
}

async function parse(response, fallbackMessage) {
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(body.error || fallbackMessage);
  }
  return body;
}

export async function getMarketplaceDashboard(clientViewId) {
  const response = await fetch(`${base(clientViewId)}/panel`, { credentials: "include" });
  return parse(response, "No se pudo cargar el panel del marketplace.");
}

export async function getMarketplaceCatalog(clientViewId) {
  const response = await fetch(`${base(clientViewId)}/catalogo`, { credentials: "include" });
  return parse(response, "No se pudo cargar el catálogo del marketplace.");
}

export async function getVendorEntitlements(clientViewId, vendorId) {
  const response = await fetch(`${base(clientViewId)}/proveedores/${vendorId}/entitlements`, {
    credentials: "include",
  });
  return parse(response, "No se pudieron cargar los entitlements del proveedor.");
}
